import { render, staticRenderFns } from "./GameLobby.vue?vue&type=template&id=aad16eea&scoped=true"
import script from "./GameLobby.vue?vue&type=script&lang=js"
export * from "./GameLobby.vue?vue&type=script&lang=js"
import style0 from "./GameLobby.vue?vue&type=style&index=0&id=aad16eea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad16eea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aad16eea')) {
      api.createRecord('aad16eea', component.options)
    } else {
      api.reload('aad16eea', component.options)
    }
    module.hot.accept("./GameLobby.vue?vue&type=template&id=aad16eea&scoped=true", function () {
      api.rerender('aad16eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lobby/GameLobby.vue"
export default component.exports